<p-card>
    <ng-container>
        <ntap-dynamic compId="ntapFilterView" #filterContainer></ntap-dynamic>
    </ng-container>
    <ng-container *ngIf="useMergedSearchView && !isTreeShown; else defaultView">
        <ng-container ntapFilterViewProvider [viewName]="mergedSearchViewName" [viewState]="mergedSearchViewStateFilter">
            <ng-container ntapListViewProvider [viewName]="mergedSearchViewName" [viewState]="mergedSearchViewState">
                <app-ntap-list [dokumentacija]="true" openAkcija="dokumentacija_defaultItemView_readonly_action"></app-ntap-list>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-template #defaultView>
        <ng-container *ngIf="files1$ | async as files">
            <p-splitter [panelSizes]="sizes" *ngIf="useChildrenListView" [styleClass]="isCollapsed ? 'no-resize' : ''">
                <ng-template pTemplate>
                    <ng-container *ngTemplateOutlet="tree"></ng-container>
                </ng-template>
                <ng-template pTemplate>
                    <ng-container *ngIf="childrenListState$ | async as childrenListState">
                        <ng-container ntapFilterViewProvider [viewName]="childrenListViewName">
                            <ng-container ntapListViewProvider [viewName]="childrenListViewName" [viewState]="childrenListState" #childrenListViewProvider="ntapListViewProvider">
                                <app-ntap-list [dokumentacija]="true"
                                    openAkcija="dokumentacija_defaultItemView_readonly_action"></app-ntap-list>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </p-splitter>
    
            <ng-template #tree>
                    <div class="treenav-toolbar">
                        <a class="splitter-toggle" [class.rotated]="isCollapsed" (click)="toggleLeft()" pRipple *ngIf="useChildrenListView">
                            <i class="pi pi-chevron-left"></i>
                        </a>
                        <app-list-toolbar [showTitle]="showToolbarTitle" [title]="(treeTitle$ | async) ?? ''"></app-list-toolbar>
                    </div>
                <p-tree [propagateSelectionUp]="propagateSelectionUp" [propagateSelectionDown]="propagateSelectionDown"
                    [value]="files" [selectionMode]="selectionMode" [(selection)]="selectedFiles" [draggableNodes]="true"
                    [droppableNodes]="true" [validateDrop]="true" (onNodeDrop)="onNodeDrop($event)" draggableScope="files"
                    droppableScope="files" (onNodeExpand)="nodeExpand($event)" (onNodeCollapse)="nodeCollapse($event)"
                    (onNodeSelect)="onNodeSelect($event)" [loading]="(loadingState$ | async) ?? true" emptyMessage="Nema podataka">
    
                    <ng-template let-node pTemplate="default">
                        <div>
                            <ng-container ntapListItemProvider [item]="node.data" [listIndex]="node.id">
                                <div class="flex flex-wrap align-items-center justify-content-center">
                                    <span [class]="node.lockedIconClass"></span>
                                    <span class="m-2 vertical-align-middle">{{node.label}}</span>
                                    <div *ngIf="node.selectable">
                                        <ntap-dynamic [compId]="tableToolbarCompId1"></ntap-dynamic>
                                    </div>
    
                                </div>
                            </ng-container>
                        </div>
    
                    </ng-template>
                    <ng-template let-node pTemplate="url">
    
                        <button pButton class="custom-button" pRipple type="button" label="Učitaj više"
                            class="mr-2 p-button-info" pTooltip="Učitaj više rezultata." icon="pi pi-arrow-down"
                            (click)="this.loadMore(node)"></button>
    
                    </ng-template>
    
                    <ng-template let-node pTemplate="urlRoot">
                        <button pButton class="custom-button" pRipple type="button" label="Učitaj više"
                            class="mr-2 p-button-info" pTooltip="Učitaj više rezultata." icon="pi pi-arrow-down"
                            (click)="this.loadMoreRootsClick()"></button>
                    </ng-template>
    
                </p-tree>
          
            </ng-template>
    
            <ng-container *ngIf="!useChildrenListView">
                <ng-container *ngTemplateOutlet="tree"></ng-container>
            </ng-container>
    
        </ng-container>
    </ng-template>

</p-card>
<ntap-view-window target="detail" [contentTemplate]="viewWindowContent">

    <ng-template #viewWindowContent let-defaultTemplate>

        <ntap-prime-popupview appendTo="body" [modal]="true">

            <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>

        </ntap-prime-popupview>

    </ng-template>

</ntap-view-window>
<p-toast [preventOpenDuplicates]="true"></p-toast>
<app-premjesti-dialog></app-premjesti-dialog>

<div class="flex justify-content-center">
    <p-dialog header="" [modal]="true" [(visible)]="displayDialog" [style]="{ width: '25rem' }">
        <span class="p-text-secondary block mb-5">{{ dropDialogMessage }}</span>       
        <div class="flex justify-content-end gap-2">
            <p-button label="Odustani" severity="secondary" (click)="displayDialog = false" />
            <p-button label="Potvrdi" (click)="confirmDrop()" />
        </div>
    </p-dialog>
</div>


